export enum AutoCompleteDataSourceEnum {
  SUBURB = 'searchSuburb',
  PARTNER_FUNDING_ORGANISATION = 'searchPartnerFundingOrganisation',
}
